import './pricelist.css';

export default function Main() {
    return (
        <div id="pricelist" className="pricelist">
            <h2 className="pricelist-title">Cenovnik</h2>
            <div>
                <table className="price-list-table">
                    <thead>
                        <tr>
                            <th>Broj učenika</th>
                            <th>Cena</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Individualno</td>
                            <td>1000 din.</td>
                        </tr>
                        <tr>
                            <td>Grupno</td>
                            <td>500 din.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}